import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { Description } from './components/description';
import { RequestData } from './components/request-data';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useResourceApprovalsDetails } from '@/data/subsidy/resource-approvals/details';
import { Skeleton } from '@/packages/subsidy-management/components/skeleton';

export const Review = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { resourceApprovalsDetails, isLoading } = useResourceApprovalsDetails(
    id || ''
  );

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Gestão de reembolsos"
        handleBackNavigation={() => navigate('/empresa/gestao-de-reembolsos')}
      />
      {isLoading && <Skeleton />}
      {resourceApprovalsDetails && (
        <Stack gap={2}>
          <RequestData resourceApprovalsDetails={resourceApprovalsDetails} />
          <Description resourceApprovalsDetails={resourceApprovalsDetails} />
        </Stack>
      )}
    </PageContainer>
  );
};
